<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <strong>Plano de Ação</strong>
          </header>

          <div class="card-body p-0">
            <b-tabs card>

              <!-- ── Aba Admin ────────────────────────────────────────────── -->
              <b-tab v-if="isAdmin" title="Planejamento">
                <b-tabs pills>

                  <!-- Admin: Eixos -->
                  <b-tab title="Eixos Estratégicos">
                    <div class="d-flex justify-content-end mb-3">
                      <button class="btn btn-primary btn-sm mr-2" @click="abrirImportarProgramasAdmin">
                        <i class="fa fa-file-excel mr-1"></i> Importar Planilha
                      </button>
                      <button class="btn btn-primary btn-sm" @click="abrirNovoEixoAdmin">
                        <i class="fa fa-plus mr-1"></i> Novo Eixo
                      </button>
                    </div>
                    <div v-if="loadingAdminAxes" class="text-center py-4">
                      <RotateSquare size="40px" class="loading-position animated fadeIn" />
                    </div>
                    <b-table v-else :items="adminAxes" :fields="adminAxeFields" responsive hover small show-empty empty-text="Nenhum eixo cadastrado.">
                      <template #cell(is_active)="{ item }">
                        <b-badge :variant="item.is_active ? 'success' : 'secondary'">{{ item.is_active ? 'Ativo' : 'Inativo' }}</b-badge>
                      </template>
                      <template #cell(acoes)="{ item }">
                        <button class="btn btn-primary btn-sm mr-1" @click="abrirEditarEixoAdmin(item)"><i class="fa fa-pencil-alt"></i></button>
                        <button class="btn btn-danger btn-sm" @click="excluirEixoAdmin(item)"><i class="fa fa-trash"></i></button>
                      </template>
                    </b-table>
                  </b-tab>

                  <!-- Admin: Programas -->
                  <b-tab title="Programas" @click="carregarAdminPrograms">
                    <div class="d-flex justify-content-end mb-3">
                      <button class="btn btn-primary btn-sm mr-2" @click="abrirImportarProgramasAdmin">
                        <i class="fa fa-file-excel mr-1"></i> Importar Planilha
                      </button>
                      <button class="btn btn-primary btn-sm" @click="abrirNovoProgramaAdmin">
                        <i class="fa fa-plus mr-1"></i> Novo Programa
                      </button>
                    </div>
                    <div v-if="loadingAdminPrograms" class="text-center py-4">
                      <RotateSquare size="40px" class="loading-position animated fadeIn" />
                    </div>
                    <b-table v-else :items="adminPrograms" :fields="adminProgramFields" responsive hover small show-empty empty-text="Nenhum programa cadastrado.">
                      <template #cell(unit)="{ item }">
                        {{ item.unit === 'percentage' ? 'Porcentagem (%)' : 'Quantidade' }}
                      </template>
                      <template #cell(goals)="{ item }">
                        <small>2a: {{ item.goal_2yr !== null ? item.goal_2yr : '—' }} | 5a: {{ item.goal_5yr !== null ? item.goal_5yr : '—' }} | 10a: {{ item.goal_10yr !== null ? item.goal_10yr : '—' }}</small>
                      </template>
                      <template #cell(is_active)="{ item }">
                        <b-badge :variant="item.is_active ? 'success' : 'secondary'">{{ item.is_active ? 'Ativo' : 'Inativo' }}</b-badge>
                      </template>
                      <template #cell(acoes)="{ item }">
                        <button class="btn btn-info btn-sm mr-1" @click="abrirGerenciarVinculosAdmin(item)" title="Vínculos prog. públicos"><i class="fa fa-link"></i></button>
                        <button class="btn btn-primary btn-sm mr-1" @click="abrirEditarProgramaAdmin(item)"><i class="fa fa-pencil-alt"></i></button>
                        <button class="btn btn-danger btn-sm" @click="excluirProgramaAdmin(item)"><i class="fa fa-trash"></i></button>
                      </template>
                    </b-table>
                  </b-tab>

                  <!-- Admin: Programas Públicos -->
                  <b-tab title="Programas Públicos" @click="carregarAdminPublicPrograms">
                    <div class="d-flex justify-content-end mb-3">
                      <button class="btn btn-primary btn-sm mr-2" @click="abrirImportarProgramasAdmin">
                        <i class="fa fa-file-excel mr-1"></i> Importar Planilha
                      </button>
                      <button class="btn btn-primary btn-sm" @click="abrirNovoPublicProgramAdmin">
                        <i class="fa fa-plus mr-1"></i> Novo Programa Público
                      </button>
                    </div>
                    <div v-if="loadingAdminPublicPrograms" class="text-center py-4">
                      <RotateSquare size="40px" class="loading-position animated fadeIn" />
                    </div>
                    <b-table v-else :items="adminPublicPrograms" :fields="adminPublicProgramFields" responsive hover small show-empty empty-text="Nenhum programa público cadastrado.">
                      <template #cell(logo)="{ item }">
                        <img v-if="item.logo_url" :src="item.logo_url" style="max-height:36px;max-width:60px;object-fit:contain;" />
                        <span v-else class="text-muted small">—</span>
                      </template>
                      <template #cell(is_active)="{ item }">
                        <b-badge :variant="item.is_active ? 'success' : 'secondary'">{{ item.is_active ? 'Ativo' : 'Inativo' }}</b-badge>
                      </template>
                      <template #cell(acoes)="{ item }">
                        <button class="btn btn-secondary btn-sm mr-1" @click="abrirUploadLogoAdmin(item)" title="Upload logo"><i class="fa fa-image"></i></button>
                        <button class="btn btn-primary btn-sm mr-1" @click="abrirEditarPublicProgramAdmin(item)"><i class="fa fa-pencil-alt"></i></button>
                        <button class="btn btn-danger btn-sm" @click="excluirPublicProgramAdmin(item)"><i class="fa fa-trash"></i></button>
                      </template>
                    </b-table>
                  </b-tab>

                </b-tabs>
              </b-tab>

              <!-- ── Aba Técnico ──────────────────────────────────────────── -->
              <b-tab title="Plano de Ação">
                <div class="d-flex justify-content-end mb-2">
                  <button
                    class="btn btn-success btn-sm d-inline-flex align-items-center"
                    :disabled="exportingExcel || loadingTecnico"
                    @click="ExportarPlanilha"
                  >
                    <i class="fa fa-file-excel mr-1"></i>
                    {{ exportingExcel ? "Exportando..." : "Exportar Excel" }}
                  </button>
                </div>
                <!-- Data de Início do Plano -->
                <div class="d-flex align-items-center flex-wrap mb-3 p-2 border rounded bg-light" style="gap:10px">
                  <i class="fa fa-calendar-alt text-muted"></i>
                  <div>
                    <span class="small font-weight-bold d-block">Data de Início do Plano</span>
                    <span class="small text-muted">Define a janela de cálculo das metas (2, 5 e 10 anos)</span>
                  </div>
                  <div class="d-flex align-items-center flex-wrap ml-auto" style="gap:8px">
                    <span v-if="planStartDate" class="small text-muted">
                      2a: até {{ periodoFim(2) }} &middot;
                      5a: até {{ periodoFim(5) }} &middot;
                      10a: até {{ periodoFim(10) }}
                    </span>
                    <b-form-input
                      v-model="planStartDate"
                      type="date"
                      size="sm"
                      style="width:160px"
                      :disabled="savingPlanStartDate || !planStartDateVarId"
                    />
                    <button
                      class="btn btn-success btn-sm"
                      :disabled="savingPlanStartDate || !planStartDateVarId"
                      @click="salvarDataInicio"
                    >
                      <i v-if="savingPlanStartDate" class="fa fa-spinner fa-spin mr-1"></i>
                      <i v-else class="fa fa-save mr-1"></i>Salvar
                    </button>
                  </div>
                </div>

                <div v-if="loadingTecnico" class="text-center py-5">
                  <RotateSquare size="50px" class="loading-position animated fadeIn" />
                </div>
                <div v-else>
                  <div class="table-responsive ap-table-wrapper">
                    <table class="table table-bordered table-sm ap-table mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th style="min-width:200px">Eixo Estratégico</th>
                          <th style="min-width:220px">Programa</th>
                          <th style="min-width:160px">Objetivos Estratégicos</th>
                          <th style="min-width:160px">Atores Estratégicos</th>
                          <th style="min-width:160px">Meta Tangível</th>
                          <th style="min-width:150px">Unidade</th>
                          <th style="min-width:72px" class="text-center">2 Anos</th>
                          <th style="min-width:72px" class="text-center">5 Anos</th>
                          <th style="min-width:72px" class="text-center">10 Anos</th>
                          <th style="min-width:190px">Prog. Públicos</th>
                          <th style="min-width:80px" class="text-center">Status</th>
                          <th style="min-width:95px" class="text-center">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, idx) in rows" :key="row._key" :class="rowClass(row)">

                          <!-- Eixo Estratégico -->
                          <td>
                            <b-form-select
                              v-model="row._axisSelectValue"
                              :options="axisOptions"
                              size="sm"
                              @change="onAxisChange(row)"
                            />
                            <b-form-input
                              v-if="row._axisSelectValue === '__new__'"
                              v-model="row.axis_name"
                              size="sm"
                              class="mt-1"
                              placeholder="Nome do novo eixo..."
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Programa -->
                          <td>
                            <b-form-select
                              v-model="row._programSelectValue"
                              :options="programOptionsForRow(row)"
                              :disabled="!row._axisSelectValue"
                              size="sm"
                              @change="onProgramChange(row)"
                            />
                            <b-form-input
                              v-if="row._programSelectValue === '__custom__'"
                              v-model="row.program_name"
                              size="sm"
                              class="mt-1"
                              placeholder="Nome do programa..."
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Objetivos Estratégicos -->
                          <td>
                            <b-form-textarea
                              v-model="row.strategic_objective"
                              rows="2"
                              size="sm"
                              class="ap-textarea"
                              placeholder="..."
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Atores Estratégicos -->
                          <td>
                            <b-form-textarea
                              v-model="row.strategic_actors"
                              rows="2"
                              size="sm"
                              class="ap-textarea"
                              placeholder="..."
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Meta Tangível -->
                          <td>
                            <b-form-textarea
                              v-model="row.tangible_goal"
                              rows="2"
                              size="sm"
                              class="ap-textarea"
                              placeholder="..."
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Unidade -->
                          <td>
                            <b-form-select
                              v-model="row.unit"
                              :options="unitOptions"
                              size="sm"
                              @change="onFieldChange(row)"
                            />
                            <b-form-input
                              v-model="row.unit_label"
                              size="sm"
                              class="mt-1"
                              placeholder="Rótulo (ex: árvores)"
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Meta 2 Anos -->
                          <td class="text-center">
                            <b-form-input
                              v-model.number="row.goal_2yr"
                              type="number"
                              min="0"
                              size="sm"
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Meta 5 Anos -->
                          <td class="text-center">
                            <b-form-input
                              v-model.number="row.goal_5yr"
                              type="number"
                              min="0"
                              size="sm"
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Meta 10 Anos -->
                          <td class="text-center">
                            <b-form-input
                              v-model.number="row.goal_10yr"
                              type="number"
                              min="0"
                              size="sm"
                              @input="onFieldChange(row)"
                            />
                          </td>

                          <!-- Programas Públicos -->
                          <td>
                            <div v-if="row.linked_public_programs.length" class="mb-1">
                              <span
                                v-for="pp in row.linked_public_programs"
                                :key="pp.id"
                                class="badge badge-info badge-pp mr-1 mb-1"
                                style="cursor:pointer"
                                @click="verDetalhesPp(pp)"
                              >
                                {{ pp.name }}
                                <button type="button" class="btn-remove-pp" @click.stop="removePpFromRow(row, pp)">×</button>
                              </span>
                            </div>
                            <div v-if="availablePpsForRow(row).length > 1" class="d-flex align-items-center mb-1">
                              <b-form-select
                                v-model="row._addPpId"
                                :options="availablePpsForRow(row)"
                                size="sm"
                                style="max-width:120px;min-width:80px"
                              />
                              <button
                                class="btn btn-secondary btn-sm ml-1 px-2"
                                :disabled="!row._addPpId"
                                @click="addPpToRow(row)"
                                title="Vincular"
                              ><i class="fa fa-link"></i></button>
                            </div>
                            <button
                              class="btn btn-link btn-sm p-0 d-block"
                              @click="abrirNovoPublicProgramParaLinha(row)"
                            >
                              <small><i class="fa fa-plus mr-1"></i>Novo prog. público</small>
                            </button>
                          </td>

                          <!-- Status -->
                          <td class="text-center align-middle">
                            <b-badge v-if="row._status === 'saved'" variant="success" class="ap-badge">Salvo</b-badge>
                            <b-badge v-else-if="row._status === 'modified'" variant="warning" class="ap-badge">Alterado</b-badge>
                            <div v-if="row._error" class="ap-row-error text-danger small">{{ row._error }}</div>
                          </td>

                          <!-- Ações -->
                          <td class="text-center align-middle" style="white-space:nowrap">
                            <div class="d-flex justify-content-center align-items-center flex-nowrap" style="gap:4px">
                              <button
                                class="btn btn-success btn-sm"
                                :disabled="row._saving"
                                @click="saveRow(row)"
                                title="Salvar"
                              >
                                <i v-if="row._saving" class="fa fa-spinner fa-spin"></i>
                                <i v-else class="fa fa-check"></i>
                              </button>
                              <button
                                v-if="row.program_id"
                                class="btn btn-info btn-sm"
                                @click="abrirProgressoLinha(row)"
                                title="Registrar progresso"
                              ><i class="fa fa-chart-line"></i></button>
                              <button
                                class="btn btn-danger btn-sm"
                                :disabled="row._saving"
                                @click="deleteRow(row, idx)"
                                title="Excluir"
                              ><i class="fa fa-trash"></i></button>
                            </div>
                          </td>

                        </tr>
                        <tr>
                          <td colspan="12">
                            <button class="btn btn-success btn-sm" @click="adicionarLinha">
                              <i class="fa fa-plus mr-1"></i> Adicionar Linha
                            </button>
                            <span class="text-muted small ml-3">{{ rows.length }} linha(s)</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>

              <!-- ── Aba Progresso das Metas ────────────────────────────── -->
              <b-tab title="Progresso das Metas" @click="ativarAbaProgresso">
                <div v-if="loadingProgressTab" class="text-center py-5">
                  <RotateSquare size="50px" class="loading-position animated fadeIn" />
                </div>
                <div v-else>
                  <!-- Controles: filtro de período -->
                  <div class="d-flex align-items-end mb-4 flex-wrap">
                    <div class="mb-2">
                      <label class="mb-1 small font-weight-bold text-muted d-block">Período</label>
                      <div class="btn-group">
                        <button
                          :class="['btn btn-sm', yearFilter === 2 ? 'btn-primary' : 'btn-secondary']"
                          @click="yearFilter = 2"
                        >2 Anos</button>
                        <button
                          :class="['btn btn-sm', yearFilter === 5 ? 'btn-primary' : 'btn-secondary']"
                          @click="yearFilter = 5"
                        >5 Anos</button>
                        <button
                          :class="['btn btn-sm', yearFilter === 10 ? 'btn-primary' : 'btn-secondary']"
                          @click="yearFilter = 10"
                        >10 Anos</button>
                      </div>
                    </div>
                    <div class="ml-auto mb-2 d-flex gap-2" style="gap:8px">
                      <button
                        class="btn btn-success btn-sm"
                        @click="$router.push({ name: 'ActionPlanPresentation' })"
                        title="Abrir apresentação dos progressos"
                      >
                        <i class="fa fa-play mr-1"></i> Apresentar
                      </button>
                      <button
                        class="btn btn-secondary btn-sm"
                        :disabled="loadingProgressTab"
                        title="Atualizar dados de progresso"
                        @click="recarregarProgressos"
                      >
                        <i :class="['fa', loadingProgressTab ? 'fa-spinner fa-spin' : 'fa-sync-alt']"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Label do período calculado -->
                  <div v-if="planStartDate" class="mb-3">
                    <small class="text-muted">
                      <i class="fa fa-calendar-alt mr-1"></i>
                      Janela considerada para <strong>{{ yearFilter }} anos</strong>: {{ periodoLabel(yearFilter) }}
                    </small>
                  </div>

                  <!-- Seleção de eixo: lista de botões -->
                  <div class="mb-4">
                    <label class="small font-weight-bold text-muted d-block mb-2">Eixo Estratégico</label>
                    <div v-if="axes.length" class="d-flex flex-wrap">
                      <button
                        v-for="axis in axes"
                        :key="axis.id"
                        :class="['btn btn-sm mr-2 mb-2', progressSelectedAxisId === axis.id ? 'btn-primary' : 'btn-secondary']"
                        @click="progressSelectedAxisId = axis.id"
                      >{{ axis.name }}</button>
                    </div>
                    <span v-else class="text-muted small">Nenhum eixo cadastrado.</span>
                  </div>

                  <!-- Gráfico de barras: programas do eixo selecionado -->
                  <div class="card mb-4">
                    <div class="card-header py-2 d-flex align-items-center">
                      <strong>Progresso por Programa</strong>
                      <span v-if="progressAxisName" class="badge badge-secondary ml-2">{{ progressAxisName }}</span>
                    </div>
                    <div class="card-body p-2">
                      <div v-if="!progressSelectedAxisId" class="text-center text-muted py-4">
                        <i class="fa fa-chart-bar fa-2x mb-2 d-block"></i>
                        Selecione um eixo acima para visualizar os programas.
                      </div>
                      <div v-else-if="!progressPrograms.length" class="text-muted text-center py-3 small">
                        Nenhum programa cadastrado neste eixo.
                      </div>
                      <highcharts v-else-if="barChartOptions" :options="barChartOptions" />
                      <div v-else class="text-muted text-center py-3 small">
                        Nenhuma meta definida neste eixo.
                      </div>
                    </div>
                  </div>

                  <!-- Gráficos de pizza: um por eixo -->
                  <div v-if="pieChartsPerAxis.length">
                    <h6 class="mb-3">
                      % da Meta por Eixo
                      <small class="text-muted font-weight-normal ml-1">({{ yearFilter }} anos)</small>
                    </h6>
                    <div class="row">
                      <div
                        v-for="pc in pieChartsPerAxis"
                        :key="pc.axisId"
                        class="col-xl-3 col-lg-4 col-md-6 col-12 mb-4"
                      >
                        <div class="card h-100">
                          <div class="card-header py-2 text-center">
                            <strong class="small">{{ pc.axisName }}</strong>
                          </div>
                          <div class="card-body p-1 d-flex flex-column align-items-center">
                            <highcharts :options="pc.options" style="width:100%;" />
                            <div class="text-center mt-1 pb-2">
                              <span
                                class="h5 font-weight-bold"
                                :class="pc.pct >= 100 ? 'text-success' : pc.pct >= 50 ? 'text-warning' : 'text-danger'"
                              >{{ pc.pct }}%</span>
                              <div class="text-muted small">da meta atingida</div>
                              <div class="text-muted" style="font-size:11px;">Atingido: {{ pc.achieved }} / Meta: {{ pc.goal }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Modal: Progresso de meta ─────────────────────────────────────────── -->
    <b-modal v-model="modalProgresso" :title="selectedProgram ? 'Progresso — ' + selectedProgram.name : 'Progresso'" size="lg" ok-only ok-title="Fechar" @hidden="resetProgressoModal">
      <div v-if="selectedProgram" class="mb-3 p-2 bg-light rounded">
        <div v-if="selectedProgram.unit_label" class="mb-2 small text-muted">
          <i class="fa fa-ruler mr-1"></i> Unidade: <strong class="text-dark">{{ selectedProgram.unit_label }}</strong>
          <span class="ml-1">({{ selectedProgram.unit === 'percentage' ? 'porcentagem' : 'quantidade' }})</span>
        </div>
        <div class="d-flex flex-wrap">
          <div class="mr-4"><small class="text-muted d-block">Meta 2 anos</small><strong>{{ selectedProgram.goal_2yr !== null ? selectedProgram.goal_2yr : '—' }} {{ unitSuffix(selectedProgram) }}</strong></div>
          <div class="mr-4"><small class="text-muted d-block">Meta 5 anos</small><strong>{{ selectedProgram.goal_5yr !== null ? selectedProgram.goal_5yr : '—' }} {{ unitSuffix(selectedProgram) }}</strong></div>
          <div><small class="text-muted d-block">Meta 10 anos</small><strong>{{ selectedProgram.goal_10yr !== null ? selectedProgram.goal_10yr : '—' }} {{ unitSuffix(selectedProgram) }}</strong></div>
        </div>
      </div>

      <h6 class="mb-2">Registrar Novo Valor</h6>
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label><strong>Valor Atingido</strong></label>
            <b-input-group :append="selectedProgram ? unitSuffix(selectedProgram) : ''">
              <b-form-input v-model.number="progressoForm.achieved_value" type="number" min="0" step="0.01" placeholder="0" />
            </b-input-group>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label><strong>Data de Referência</strong></label>
            <b-form-input v-model="progressoForm.reference_date" type="date" />
          </div>
        </div>
        <div class="col-4 d-flex align-items-end">
          <div class="form-group w-100">
            <label>&nbsp;</label>
            <button class="btn btn-success btn-sm btn-block" :disabled="savingProgresso" @click="salvarProgresso">
              <i v-if="savingProgresso" class="fa fa-spinner fa-spin mr-1"></i>
              <i v-else class="fa fa-plus mr-1"></i> Adicionar
            </button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Observação <small class="text-muted">(opcional)</small></label>
        <b-form-textarea v-model="progressoForm.notes" rows="2" />
      </div>

      <hr />
      <div v-if="loadingProgresso" class="text-center py-3"><i class="fa fa-spinner fa-spin"></i></div>
      <div v-else>
        <h6 class="mb-2">Histórico de Registros</h6>
        <div v-if="progressEntries.length === 0" class="text-muted small">Nenhum registro ainda.</div>
        <b-table v-else :items="progressEntries" :fields="progressFields" responsive small hover bordered class="mb-0 border">
          <template #cell(achieved_value)="{ item }">
            {{ item.achieved_value }} {{ selectedProgram ? unitSuffix(selectedProgram) : '' }}
          </template>
          <template #cell(acoes)="{ item }">
            <button class="btn btn-danger btn-sm" @click="excluirProgresso(item)"><i class="fa fa-trash"></i></button>
          </template>
        </b-table>
      </div>
    </b-modal>

    <!-- ── Modal: Novo Programa Público ────────────────────────────────────── -->
    <b-modal v-model="modalNovoPublicProgram" title="Novo Programa Público" @ok="salvarNovoPublicProgram" ok-title="Salvar" cancel-title="Cancelar" @hidden="resetNovoPublicProgramForm">
      <div class="form-group">
        <label><strong>Nome</strong></label>
        <b-form-input v-model="novoPublicProgramForm.name" placeholder="Ex: Programa Nacional de Arborização" />
      </div>
      <div class="form-group">
        <label>Descrição <small class="text-muted">(opcional)</small></label>
        <b-form-textarea v-model="novoPublicProgramForm.description" rows="2" />
      </div>
      <div class="form-group">
        <label>Logo <small class="text-muted">(opcional, pode adicionar depois)</small></label>
        <b-form-file v-model="novoPublicProgramLogo" accept="image/*" placeholder="Escolha uma imagem..." />
      </div>
    </b-modal>

    <!-- ── Modal: Admin — Eixo ─────────────────────────────────────────────── -->
    <b-modal v-model="modalEixoAdmin" :title="editandoEixoAdmin ? 'Editar Eixo (Template)' : 'Novo Eixo (Template)'" @ok="salvarEixoAdmin" ok-title="Salvar" cancel-title="Cancelar" @hidden="resetEixoAdminForm">
      <div class="form-group">
        <label><strong>Nome</strong></label>
        <b-form-input v-model="eixoAdminForm.name" />
      </div>
      <div class="form-group">
        <label>Descrição</label>
        <b-form-textarea v-model="eixoAdminForm.description" rows="2" />
      </div>
      <div class="form-group">
        <b-form-checkbox v-model="eixoAdminForm.is_active">Ativo</b-form-checkbox>
      </div>
    </b-modal>

    <!-- ── Modal: Admin — Programa ─────────────────────────────────────────── -->
    <b-modal v-model="modalProgramaAdmin" :title="editandoProgramaAdmin ? 'Editar Programa (Template)' : 'Novo Programa (Template)'" @ok="salvarProgramaAdmin" ok-title="Salvar" cancel-title="Cancelar" size="lg" @hidden="resetProgramaAdminForm">
      <div class="form-group">
        <label><strong>Eixo Estratégico</strong></label>
        <b-form-select v-model="programaAdminForm.strategic_axis_id" :options="adminAxisOptions" />
      </div>
      <div class="form-group">
        <label><strong>Nome</strong></label>
        <b-form-input v-model="programaAdminForm.name" />
      </div>
      <div class="form-group">
        <label>Descrição</label>
        <b-form-textarea v-model="programaAdminForm.description" rows="2" />
      </div>
      <div class="form-group">
        <label>Objetivo Estratégico</label>
        <b-form-textarea v-model="programaAdminForm.strategic_objective" rows="2" />
      </div>
      <div class="form-group">
        <label>Atores Estratégicos</label>
        <b-form-textarea v-model="programaAdminForm.strategic_actors" rows="2" placeholder="Ex: Secretaria de Meio Ambiente, ONGs parceiras..." />
      </div>
      <div class="form-group">
        <label>Meta Tangível</label>
        <b-form-textarea v-model="programaAdminForm.tangible_goal" rows="2" />
      </div>
      <div class="form-group">
        <label>Formato de Mensuração</label>
        <b-form-select v-model="programaAdminForm.unit" :options="unitOptions" />
      </div>
      <div class="form-group">
        <label>Rótulo da Unidade <small class="text-muted">(o que está sendo medido)</small></label>
        <b-form-input v-model="programaAdminForm.unit_label" placeholder="Ex: Árvores plantadas, % de cobertura vegetal..." />
      </div>
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label>Meta 2 anos</label>
            <b-form-input v-model.number="programaAdminForm.goal_2yr" type="number" min="0" />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>Meta 5 anos</label>
            <b-form-input v-model.number="programaAdminForm.goal_5yr" type="number" min="0" />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>Meta 10 anos</label>
            <b-form-input v-model.number="programaAdminForm.goal_10yr" type="number" min="0" />
          </div>
        </div>
      </div>
      <div v-if="editandoProgramaAdmin" class="form-group">
        <b-form-checkbox v-model="programaAdminForm.is_active">Ativo</b-form-checkbox>
      </div>
    </b-modal>

    <!-- ── Modal: Admin — Programa Público ─────────────────────────────────── -->
    <b-modal v-model="modalPublicProgramAdmin" :title="editandoPublicProgramAdmin ? 'Editar Programa Público (Template)' : 'Novo Programa Público (Template)'" @ok="salvarPublicProgramAdmin" ok-title="Salvar" cancel-title="Cancelar" @hidden="resetPublicProgramAdminForm">
      <div class="form-group">
        <label><strong>Nome</strong></label>
        <b-form-input v-model="publicProgramAdminForm.name" />
      </div>
      <div class="form-group">
        <label>Descrição</label>
        <b-form-textarea v-model="publicProgramAdminForm.description" rows="2" />
      </div>
      <div v-if="editandoPublicProgramAdmin" class="form-group">
        <b-form-checkbox v-model="publicProgramAdminForm.is_active">Ativo</b-form-checkbox>
      </div>
    </b-modal>

    <!-- ── Modal: Upload Logo Admin ─────────────────────────────────────────── -->
    <b-modal v-model="modalUploadLogo" title="Upload de Logo" @ok="salvarUploadLogoAdmin" ok-title="Enviar" cancel-title="Cancelar" :ok-disabled="!uploadLogoFile">
      <p class="text-muted small">Selecione a imagem de logo para o programa público.</p>
      <b-form-file v-model="uploadLogoFile" accept="image/*" placeholder="Escolha uma imagem..." />
      <div v-if="logoPreview" class="mt-3 text-center">
        <img :src="logoPreview" style="max-height:80px;max-width:200px;object-fit:contain;" class="border rounded p-1" />
      </div>
    </b-modal>

    <!-- ── Modal: Importar Planilha de Programas (Admin) ────────────────────── -->
    <b-modal
      v-model="modalImportPrograms"
      title="Importar Planilha de Programas"
      @ok="executarImportacaoAdmin"
      ok-title="Importar"
      cancel-title="Cancelar"
      :ok-disabled="!importProgramsFile || importingPrograms"
      @hidden="resetImportProgramsModal"
    >
      <p class="text-muted small">
        Selecione uma planilha .xlsx no modelo padrão (colunas: Eixo Estratégico, Programa,
        Objetivo estratégico, Atores estratégicos, Meta tangível, Unidade, Meta 2/5/10 anos,
        Alinhamento com PlaNAU / AdaptaCidades / Segurança). Programas com o mesmo nome e eixo
        de um template já existente serão atualizados. A planilha é rejeitada por completo se
        alguma linha estiver fora do padrão.
      </p>
      <b-form-file v-model="importProgramsFile" accept=".xlsx" placeholder="Escolha a planilha..." :disabled="importingPrograms" />
      <div v-if="importingPrograms" class="text-center mt-3">
        <RotateSquare size="30px" class="loading-position animated fadeIn" />
      </div>
      <div v-if="importProgramsResult" class="mt-3">
        <div class="alert alert-success small mb-0">
          {{ importProgramsResult.axes_created }} eixo(s) criado(s) · {{ importProgramsResult.programs_created }} programa(s) criado(s) ·
          {{ importProgramsResult.programs_updated }} atualizado(s) · {{ importProgramsResult.public_programs_created }} programa(s) público(s) criado(s) ·
          {{ importProgramsResult.links_created }} vínculo(s) criado(s)
        </div>
      </div>
      <div v-if="importProgramsErrors.length" class="mt-3">
        <div class="alert alert-danger small mb-0">
          <div class="font-weight-bold mb-1">Planilha não foi importada — corrija e reenvie:</div>
          <ul class="mb-0 pl-3">
            <li v-for="(err, idx) in importProgramsErrors" :key="idx">{{ err }}</li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- ── Modal: Detalhes programa público ─────────────────────────────────── -->
    <b-modal v-model="modalDetalhesPp" :title="selectedPpDetails ? selectedPpDetails.name : 'Programa Público'" ok-only ok-title="Fechar" @hidden="selectedPpDetails = null">
      <div v-if="selectedPpDetails">
        <div v-if="selectedPpDetails.logo_url" class="text-center mb-3">
          <img :src="selectedPpDetails.logo_url" style="max-height:80px;max-width:200px;object-fit:contain;" class="border rounded p-1" />
        </div>
        <p v-if="selectedPpDetails.description" class="mb-0">{{ selectedPpDetails.description }}</p>
        <p v-else class="text-muted mb-0">Sem descrição cadastrada.</p>
      </div>
    </b-modal>

    <!-- ── Modal: Admin — Vínculos programa × prog. público ─────────────────── -->
    <b-modal v-model="modalVinculosAdmin" :title="selectedAdminProgram ? 'Vínculos — ' + selectedAdminProgram.name : 'Vínculos'" size="lg" ok-only ok-title="Fechar" @hidden="resetVinculosAdminModal">
      <div v-if="loadingVinculosAdmin" class="text-center py-3"><i class="fa fa-spinner fa-spin"></i></div>
      <div v-else>
        <h6 class="mb-2">Vínculos atuais</h6>
        <div v-if="adminProgramLinks.length === 0" class="text-muted small mb-3">Nenhum vínculo.</div>
        <div v-else>
          <div v-for="pp in adminProgramLinks" :key="pp.id" class="d-flex align-items-center mb-2 p-2 border rounded">
            <img v-if="pp.logo_url" :src="pp.logo_url" style="max-height:32px;max-width:50px;object-fit:contain;" class="mr-2" />
            <div class="flex-grow-1"><strong>{{ pp.name }}</strong></div>
            <button class="btn btn-danger btn-sm" @click="removerVinculoAdmin(pp)"><i class="fa fa-unlink"></i></button>
          </div>
        </div>
        <hr />
        <h6 class="mb-2">Adicionar vínculo</h6>
        <div class="d-flex">
          <b-form-select v-model="novoVinculoPpIdAdmin" :options="adminPublicProgramsForSelect" class="mr-2" />
          <button class="btn btn-primary btn-sm" :disabled="!novoVinculoPpIdAdmin" @click="adicionarVinculoAdmin">
            <i class="fa fa-plus mr-1"></i> Vincular
          </button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import ActionPlanService from "../../servico/ActionPlanService";

const EMPTY_PROGRAMA = () => ({
  strategic_axis_id: null,
  name: "",
  description: "",
  strategic_objective: "",
  strategic_actors: "",
  tangible_goal: "",
  unit: "quantity",
  unit_label: "",
  goal_2yr: null,
  goal_5yr: null,
  goal_10yr: null,
});
const EMPTY_PROGRESSO = () => ({ achieved_value: null, reference_date: new Date().toISOString().split("T")[0], notes: "" });
const EMPTY_PUBLIC_PROGRAM = () => ({ name: "", description: "" });

let _rowKeyCounter = 0;
const EMPTY_ROW = () => ({
  _axisSelectValue: null,
  axis_id: null,
  _systemAxisId: null,
  axis_name: "",
  _programSelectValue: null,
  program_id: null,
  _systemProgramId: null,
  program_name: "",
  strategic_objective: "",
  strategic_actors: "",
  tangible_goal: "",
  unit: "quantity",
  unit_label: "",
  goal_2yr: null,
  goal_5yr: null,
  goal_10yr: null,
  linked_public_programs: [],
  _savedLinkedIds: [],
  _addPpId: null,
  _status: "new",
  _saving: false,
  _error: null,
  _key: "row_" + (++_rowKeyCounter),
});

export default {
  name: "PmauActionPlan",
  components: { RotateSquare },
  computed: {
    contaId() {
      const auth = this.$store.getters.getAutenticacao;
      return auth && auth.contaSelecionada ? auth.contaSelecionada.id : null;
    },
    isAdmin() {
      return this.$store.getters.isPmauAdmin;
    },
    axisOptions() {
      const result = [{ value: null, text: "— Selecione um eixo —", disabled: true }];
      if (this.adminTemplates.length) {
        result.push({
          label: "Templates do Sistema",
          options: this.adminTemplates.map((a) => ({ value: "sys_" + a.id, text: a.name })),
        });
      }
      if (this.axes.length) {
        result.push({
          label: "Meus Eixos",
          options: this.axes.map((a) => ({ value: "acc_" + a.id, text: a.name })),
        });
      }
      result.push({ value: "__new__", text: "+ Escrever novo eixo..." });
      return result;
    },
    adminAxisOptions() {
      return [
        { value: null, text: "Selecione um eixo estratégico..." },
        ...this.adminAxes.map((a) => ({ value: a.id, text: a.name })),
      ];
    },
    adminPublicProgramsForSelect() {
      const linkedIds = new Set(this.adminProgramLinks.map((p) => p.id));
      const available = this.adminPublicPrograms.filter((p) => !linkedIds.has(p.id));
      return [
        { value: null, text: "Selecione um programa público..." },
        ...available.map((p) => ({ value: p.id, text: p.name })),
      ];
    },
    allPublicPrograms() {
      const map = new Map();
      for (const pp of this.publicPrograms) {
        map.set(pp.id, pp);
      }
      for (const axis of this.adminTemplates) {
        for (const prog of axis.programs || []) {
          for (const pp of prog.linked_public_programs || []) {
            if (!map.has(pp.id)) map.set(pp.id, pp);
          }
        }
      }
      return Array.from(map.values());
    },
    logoPreview() {
      if (!this.uploadLogoFile) return null;
      return URL.createObjectURL(this.uploadLogoFile);
    },
    unitOptions() {
      return [
        { value: "quantity", text: "Quantidade" },
        { value: "percentage", text: "Porcentagem (%)" },
      ];
    },

    // ── Progresso das Metas ───────────────────────────────────────────────
    filteredLatestProgress() {
      const map = {};
      for (const [id, entries] of Object.entries(this.allProgressEntries)) {
        const filtered = this._filterByPeriod(entries, this.yearFilter);
        map[id] = filtered.length ? filtered[0].achieved_value : 0;
      }
      return map;
    },
    progressAxisName() {
      const axis = this.axes.find((a) => a.id === this.progressSelectedAxisId);
      return axis ? axis.name : "";
    },
    progressPrograms() {
      if (!this.progressSelectedAxisId) return [];
      return this.programs.filter((p) => p.strategic_axis_id === this.progressSelectedAxisId);
    },
    goalField() {
      return this.yearFilter === 2 ? "goal_2yr" : this.yearFilter === 5 ? "goal_5yr" : "goal_10yr";
    },
    barChartOptions() {
      const programs = this.progressPrograms;
      if (!programs.length) return null;

      const maxVal = Math.max(
        1,
        ...programs.map((p) => Math.max(p.goal_2yr || 0, p.goal_5yr || 0, p.goal_10yr || 0))
      );
      if (maxVal <= 0) return null;

      const categories = programs.map((p) => p.name);
      const goalField = this.goalField;
      const goalData = programs.map((p) => p[goalField] || 0);
      const achievedData = programs.map((p) => this.filteredLatestProgress[p.id] || 0);
      const yearFilter = this.yearFilter;

      return {
        chart: { type: "bar", height: Math.max(260, programs.length * 48 + 90) },
        title: { text: null },
        credits: { enabled: false },
        xAxis: { categories, title: { text: null } },
        yAxis: {
          min: 0,
          max: maxVal,
          title: { text: "Valor" },
          labels: { overflow: "justify" },
        },
        legend: { enabled: true },
        tooltip: {
          shared: true,
          formatter() {
            let s = `<b>${this.x}</b>`;
            this.points.forEach((pt) => {
              s += `<br/><span style="color:${pt.color}">●</span> ${pt.series.name}: <b>${pt.y}</b>`;
            });
            return s;
          },
        },
        plotOptions: {
          bar: { dataLabels: { enabled: true, format: "{y}" } },
        },
        series: [
          {
            name: `Meta ${yearFilter} anos`,
            data: goalData,
            color: "rgba(92, 184, 92, 0.25)",
            borderColor: "#5cb85c",
            borderWidth: 1,
          },
          {
            name: "Valor Atingido",
            data: achievedData,
            color: "#5cb85c",
          },
        ],
      };
    },
    pieChartsPerAxis() {
      const goalField = this.goalField;
      const yearFilter = this.yearFilter;
      const result = [];
      for (const axis of this.axes) {
        const progs = this.programs.filter((p) => p.strategic_axis_id === axis.id);
        if (!progs.length) continue;
        const achieved = progs.reduce((sum, p) => sum + (this.filteredLatestProgress[p.id] || 0), 0);
        const goal = progs.reduce((sum, p) => sum + (p[goalField] || 0), 0);
        if (achieved === 0 && goal === 0) continue;

        const pct = goal > 0 ? Math.round((achieved / goal) * 100) : (achieved > 0 ? 100 : 0);
        const achievedDisplay = goal > 0 ? Math.min(achieved, goal) : achieved;
        const remaining = Math.max(0, goal - achieved);

        const pieData = [];
        if (achievedDisplay > 0) {
          pieData.push({ name: "Atingido", y: achievedDisplay, color: "#5cb85c" });
        }
        if (remaining > 0) {
          pieData.push({ name: "Restante", y: remaining, color: "#e9ecef" });
        } else if (achievedDisplay === 0) {
          pieData.push({ name: "Sem progresso", y: goal > 0 ? goal : 1, color: "#e9ecef" });
        }

        result.push({
          axisId: axis.id,
          axisName: axis.name,
          pct,
          achieved,
          goal,
          options: {
            chart: { type: "pie", height: 160, margin: [10, 10, 10, 10] },
            title: { text: null },
            credits: { enabled: false },
            legend: { enabled: false },
            tooltip: {
              formatter() {
                return `<b>${this.point.name}</b>: ${this.point.y}`;
              },
            },
            plotOptions: {
              pie: {
                innerSize: "55%",
                dataLabels: { enabled: false },
              },
            },
            series: [{ name: `Meta ${yearFilter} anos`, colorByPoint: false, data: pieData }],
          },
        });
      }
      return result;
    },
  },
  data() {
    return {
      // ── Técnico ──────────────────────────────────────────────────────────
      loadingTecnico: false,
      exportingExcel: false,
      axes: [],
      programs: [],
      publicPrograms: [],
      adminTemplates: [],
      rows: [],

      // Progresso modal
      modalProgresso: false,
      selectedProgram: null,
      loadingProgresso: false,
      progressEntries: [],
      progressoForm: EMPTY_PROGRESSO(),
      savingProgresso: false,
      progressFields: [
        { key: "reference_date", label: "Data de Referência", sortable: true },
        { key: "achieved_value", label: "Valor Atingido", sortable: true },
        { key: "notes", label: "Observação" },
        { key: "acoes", label: "", thClass: "wd-50-px" },
      ],

      // Novo programa público
      modalNovoPublicProgram: false,
      novoPublicProgramForm: EMPTY_PUBLIC_PROGRAM(),
      novoPublicProgramLogo: null,
      _ppTargetRow: null,

      // Detalhes programa público
      modalDetalhesPp: false,
      selectedPpDetails: null,

      // ── Admin ─────────────────────────────────────────────────────────────
      loadingAdminAxes: false,
      adminAxes: [],
      adminPrograms: [],
      loadingAdminPrograms: false,
      adminPublicPrograms: [],
      loadingAdminPublicPrograms: false,

      modalImportPrograms: false,
      importProgramsFile: null,
      importingPrograms: false,
      importProgramsResult: null,
      importProgramsErrors: [],

      adminAxeFields: [
        { key: "name", label: "Nome", sortable: true },
        { key: "description", label: "Descrição" },
        { key: "is_active", label: "Status" },
        { key: "acoes", label: "Ações", thClass: "wd-90-px" },
      ],
      adminProgramFields: [
        { key: "name", label: "Programa", sortable: true },
        { key: "unit", label: "Unidade" },
        { key: "goals", label: "Metas" },
        { key: "is_active", label: "Status" },
        { key: "acoes", label: "Ações", thClass: "wd-120-px" },
      ],
      adminPublicProgramFields: [
        { key: "logo", label: "Logo", thClass: "wd-80-px" },
        { key: "name", label: "Nome", sortable: true },
        { key: "description", label: "Descrição" },
        { key: "is_active", label: "Status" },
        { key: "acoes", label: "Ações", thClass: "wd-100-px" },
      ],

      modalEixoAdmin: false,
      editandoEixoAdmin: null,
      eixoAdminForm: { name: "", description: "", is_active: true },

      modalProgramaAdmin: false,
      editandoProgramaAdmin: null,
      programaAdminForm: { ...EMPTY_PROGRAMA(), is_active: true },

      modalPublicProgramAdmin: false,
      editandoPublicProgramAdmin: null,
      publicProgramAdminForm: { name: "", description: "", is_active: true },

      modalUploadLogo: false,
      uploadingLogo: null,
      uploadLogoFile: null,

      modalVinculosAdmin: false,
      selectedAdminProgram: null,
      loadingVinculosAdmin: false,
      adminProgramLinks: [],
      novoVinculoPpIdAdmin: null,

      // ── Progresso das Metas ─────────────────────────────────────────────
      progressTabActivated: false,
      progressTabLoaded: false,
      loadingProgressTab: false,
      progressSelectedAxisId: null,
      yearFilter: 2,
      allProgressEntries: {},

      // ── Data de início do plano ──────────────────────────────────────────
      planStartDate: "",
      planStartDateVarId: null,
      savingPlanStartDate: false,
    };
  },
  beforeMount() {
    if (!this.contaId) {
      this.$notify({ data: ["Conta não identificada. Faça login novamente."], type: "warn", duration: 5000 });
      return;
    }
    this.carregarTudo();
    if (this.isAdmin) {
      this.carregarAdminAxes();
    }
  },
  watch: {
    loadingTecnico(val) {
      if (!val && this.progressTabActivated && !this.progressTabLoaded && !this.loadingProgressTab) {
        this.carregarTodosProgressos();
      }
    },
  },
  methods: {
    unitSuffix(program) {
      if (program.unit_label) return program.unit_label;
      return program.unit === "percentage" ? "%" : "";
    },

    // ── Exportação ──────────────────────────────────────────────────────────

    ExportarPlanilha() {
      this.exportingExcel = true;
      ActionPlanService.ExportExcel(this.contaId)
        .then((r) => {
          const blob = new Blob([r.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "plano-de-acao.xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$notify({ data: ["Erro ao exportar planilha."], type: "error" });
        })
        .finally(() => {
          this.exportingExcel = false;
        });
    },

    // ── Carregamento ────────────────────────────────────────────────────────

    carregarTudo() {
      this.loadingTecnico = true;
      Promise.all([
        ActionPlanService.ListAxes(this.contaId),
        ActionPlanService.ListProgramsWithLinks(this.contaId),
        ActionPlanService.ListPublicPrograms(this.contaId),
        ActionPlanService.GetTemplates(),
        ActionPlanService.GetVariables(this.contaId),
      ])
        .then(([axesRes, progsRes, ppsRes, templatesRes, varsRes]) => {
          this.axes = axesRes.data;
          this.programs = progsRes.data;
          this.publicPrograms = ppsRes.data;
          this.adminTemplates = templatesRes.data;
          this.rows = this.programs.map((p) => this._programToRow(p));
          const psdVar = varsRes.data.find((v) => v.code === "plan_start_date");
          if (psdVar) {
            this.planStartDateVarId = psdVar.id;
            this.planStartDate = psdVar.current_value || "";
          }
        })
        .catch(() => {
          this.$notify({ data: ["Erro ao carregar dados do plano de ação."], type: "error" });
        })
        .finally(() => {
          this.loadingTecnico = false;
        });
    },

    _programToRow(p) {
      const axis = this.axes.find((a) => a.id === p.strategic_axis_id);
      return {
        _axisSelectValue: "acc_" + p.strategic_axis_id,
        axis_id: p.strategic_axis_id,
        _systemAxisId: null,
        axis_name: axis ? axis.name : "",
        _programSelectValue: "acc_" + p.id,
        program_id: p.id,
        _systemProgramId: null,
        program_name: p.name,
        strategic_objective: p.strategic_objective || "",
        strategic_actors: p.strategic_actors || "",
        tangible_goal: p.tangible_goal || "",
        unit: p.unit || "quantity",
        unit_label: p.unit_label || "",
        goal_2yr: p.goal_2yr,
        goal_5yr: p.goal_5yr,
        goal_10yr: p.goal_10yr,
        linked_public_programs: p.linked_public_programs || [],
        _savedLinkedIds: (p.linked_public_programs || []).map((pp) => pp.id),
        _addPpId: null,
        _status: "saved",
        _saving: false,
        _error: null,
        _key: p.id,
      };
    },

    // ── Spreadsheet — linha ─────────────────────────────────────────────────

    adicionarLinha() {
      this.rows.push(EMPTY_ROW());
    },

    rowClass(row) {
      if (row._status === "saved") return "tr-saved";
      if (row._status === "modified") return "tr-modified";
      return "";
    },

    onFieldChange(row) {
      if (row._status === "saved") row._status = "modified";
    },

    // ── Cascade selects ─────────────────────────────────────────────────────

    programOptionsForRow(row) {
      const result = [{ value: null, text: "— Selecione um programa —", disabled: true }];
      if (row._systemAxisId) {
        const sysAxis = this.adminTemplates.find((a) => a.id === row._systemAxisId);
        if (sysAxis && sysAxis.programs && sysAxis.programs.length) {
          result.push({
            label: "Templates — " + sysAxis.name,
            options: sysAxis.programs.map((p) => ({ value: "sys_" + p.id, text: p.name })),
          });
        }
      } else if (row.axis_id) {
        const accProgs = this.programs.filter((p) => p.strategic_axis_id === row.axis_id);
        if (accProgs.length) {
          result.push({
            label: "Meus Programas",
            options: accProgs.map((p) => ({ value: "acc_" + p.id, text: p.name })),
          });
        }
      }
      result.push({ value: "__custom__", text: "+ Escrever próprio" });
      return result;
    },

    onAxisChange(row) {
      const value = row._axisSelectValue;
      row._programSelectValue = null;
      row._systemProgramId = null;
      row.program_id = null;
      row.program_name = "";
      row.strategic_objective = "";
      row.strategic_actors = "";
      row.tangible_goal = "";
      row.unit = "quantity";
      row.unit_label = "";
      row.goal_2yr = null;
      row.goal_5yr = null;
      row.goal_10yr = null;
      row.linked_public_programs = [];
      row._savedLinkedIds = [];

      if (value && value.startsWith("sys_")) {
        row._systemAxisId = value.replace("sys_", "");
        row.axis_id = null;
        const sysAxis = this.adminTemplates.find((a) => a.id === row._systemAxisId);
        row.axis_name = sysAxis ? sysAxis.name : "";
      } else if (value && value.startsWith("acc_")) {
        row.axis_id = value.replace("acc_", "");
        row._systemAxisId = null;
        const accAxis = this.axes.find((a) => a.id === row.axis_id);
        row.axis_name = accAxis ? accAxis.name : "";
      } else if (value === "__new__") {
        row.axis_id = null;
        row._systemAxisId = null;
        row.axis_name = "";
        row._programSelectValue = "__custom__";
      } else {
        row.axis_id = null;
        row._systemAxisId = null;
        row.axis_name = "";
      }

      if (row._status === "saved") row._status = "modified";
    },

    onProgramChange(row) {
      const value = row._programSelectValue;

      if (value && value.startsWith("sys_")) {
        const programId = value.replace("sys_", "");
        row._systemProgramId = programId;
        row.program_id = null;
        let prog = null;
        for (const axis of this.adminTemplates) {
          prog = (axis.programs || []).find((p) => p.id === programId);
          if (prog) break;
        }
        if (prog) {
          row.program_name = prog.name;
          row.strategic_objective = prog.strategic_objective || "";
          row.strategic_actors = prog.strategic_actors || "";
          row.tangible_goal = prog.tangible_goal || "";
          row.unit = prog.unit || "quantity";
          row.unit_label = prog.unit_label || "";
          row.goal_2yr = prog.goal_2yr;
          row.goal_5yr = prog.goal_5yr;
          row.goal_10yr = prog.goal_10yr;
          row.linked_public_programs = [...(prog.linked_public_programs || [])];
        }
        // Programa ainda não existe na conta — nenhum vínculo foi salvo de fato ainda.
        row._savedLinkedIds = [];
      } else if (value && value.startsWith("acc_")) {
        const programId = value.replace("acc_", "");
        row._systemProgramId = null;
        row.program_id = programId;
        const prog = this.programs.find((p) => p.id === programId);
        if (prog) {
          row.program_name = prog.name;
          row.strategic_objective = prog.strategic_objective || "";
          row.strategic_actors = prog.strategic_actors || "";
          row.tangible_goal = prog.tangible_goal || "";
          row.unit = prog.unit || "quantity";
          row.unit_label = prog.unit_label || "";
          row.goal_2yr = prog.goal_2yr;
          row.goal_5yr = prog.goal_5yr;
          row.goal_10yr = prog.goal_10yr;
          row.linked_public_programs = [...(prog.linked_public_programs || [])];
          row._savedLinkedIds = (prog.linked_public_programs || []).map((pp) => pp.id);
        }
      } else if (value === "__custom__") {
        row._systemProgramId = null;
        row.program_id = null;
        row.program_name = "";
        row.strategic_objective = "";
        row.strategic_actors = "";
        row.tangible_goal = "";
        row.unit = "quantity";
        row.unit_label = "";
        row.goal_2yr = null;
        row.goal_5yr = null;
        row.goal_10yr = null;
        row.linked_public_programs = [];
        row._savedLinkedIds = [];
      }

      if (row._status === "saved") row._status = "modified";
    },

    // ── Salvar / excluir linha ──────────────────────────────────────────────

    async saveRow(row) {
      if (!row._axisSelectValue) {
        row._error = "Selecione ou informe um eixo estratégico.";
        return;
      }
      if (row._axisSelectValue === "__new__" && !row.axis_name.trim()) {
        row._error = "Informe o nome do novo eixo.";
        return;
      }
      if (!row._programSelectValue) {
        row._error = "Selecione ou informe um programa.";
        return;
      }
      if (row._programSelectValue === "__custom__" && !row.program_name.trim()) {
        row._error = "Informe o nome do programa.";
        return;
      }

      row._saving = true;
      row._error = null;

      try {
        // 1. Resolve eixo
        let axisId = row.axis_id;
        if (!axisId) {
          const axisName = row.axis_name.trim();
          const existing = this.axes.find((a) => a.name.toLowerCase() === axisName.toLowerCase());
          if (existing) {
            axisId = existing.id;
          } else {
            const r = await ActionPlanService.CreateAxis(this.contaId, { name: axisName, description: null });
            axisId = r.data.id;
            this.axes.push(r.data);
          }
        }

        // 2. Cria ou atualiza programa
        const payload = {
          strategic_axis_id: axisId,
          name: row.program_name.trim() || (row._systemProgramId ? this._findSysProgramName(row._systemProgramId) : ""),
          description: null,
          strategic_objective: row.strategic_objective || null,
          strategic_actors: row.strategic_actors || null,
          tangible_goal: row.tangible_goal || null,
          unit: row.unit || "quantity",
          unit_label: row.unit_label || null,
          goal_2yr: row.goal_2yr !== "" ? row.goal_2yr : null,
          goal_5yr: row.goal_5yr !== "" ? row.goal_5yr : null,
          goal_10yr: row.goal_10yr !== "" ? row.goal_10yr : null,
        };

        let programId = row.program_id;
        if (programId) {
          const r = await ActionPlanService.UpdateProgram(this.contaId, programId, payload);
          const idx = this.programs.findIndex((p) => p.id === programId);
          const updated = { ...r.data, linked_public_programs: row.linked_public_programs };
          if (idx >= 0) this.$set(this.programs, idx, updated);
        } else {
          const r = await ActionPlanService.CreateProgram(this.contaId, payload);
          programId = r.data.id;
          this.programs.push({ ...r.data, linked_public_programs: [] });
        }

        // 3. Sincroniza vínculos de programas públicos
        const currentIds = new Set(row.linked_public_programs.map((pp) => pp.id));
        const savedIds = new Set(row._savedLinkedIds);
        for (const pp of row.linked_public_programs) {
          if (!savedIds.has(pp.id)) {
            await ActionPlanService.AddProgramLink(this.contaId, programId, pp.id);
          }
        }
        for (const savedId of row._savedLinkedIds) {
          if (!currentIds.has(savedId)) {
            await ActionPlanService.RemoveProgramLink(this.contaId, programId, savedId);
          }
        }

        // 4. Atualiza estado da linha
        row.axis_id = axisId;
        row.program_id = programId;
        row._axisSelectValue = "acc_" + axisId;
        row._programSelectValue = "acc_" + programId;
        row._systemAxisId = null;
        row._systemProgramId = null;
        row._savedLinkedIds = [...currentIds];
        row._status = "saved";

        this.$notify({ data: ["Programa salvo com sucesso."], type: "success" });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Erro ao salvar.";
        row._error = msg;
        this.$notify({ data: [msg], type: "error" });
      } finally {
        row._saving = false;
      }
    },

    _findSysProgramName(programId) {
      for (const axis of this.adminTemplates) {
        const prog = (axis.programs || []).find((p) => p.id === programId);
        if (prog) return prog.name;
      }
      return "";
    },

    async deleteRow(row, idx) {
      if (row.program_id) {
        if (!confirm(`Excluir o programa "${row.program_name}"?`)) return;
        try {
          await ActionPlanService.DeleteProgram(this.contaId, row.program_id);
          this.programs = this.programs.filter((p) => p.id !== row.program_id);
        } catch {
          this.$notify({ data: ["Erro ao excluir programa."], type: "error" });
          return;
        }
      }
      this.rows.splice(idx, 1);
    },

    // ── Programas públicos na linha ─────────────────────────────────────────

    availablePpsForRow(row) {
      const linkedIds = new Set(row.linked_public_programs.map((pp) => pp.id));
      const available = this.allPublicPrograms.filter((pp) => !linkedIds.has(pp.id));
      return [
        { value: null, text: "— Selecionar —", disabled: true },
        ...available.map((pp) => ({ value: pp.id, text: pp.name })),
      ];
    },

    addPpToRow(row) {
      if (!row._addPpId) return;
      const pp = this.allPublicPrograms.find((p) => p.id === row._addPpId);
      if (pp) {
        row.linked_public_programs.push({ id: pp.id, name: pp.name, logo_url: pp.logo_url || null });
        if (row._status === "saved") row._status = "modified";
      }
      row._addPpId = null;
    },

    removePpFromRow(row, pp) {
      row.linked_public_programs = row.linked_public_programs.filter((p) => p.id !== pp.id);
      if (row._status === "saved") row._status = "modified";
    },

    verDetalhesPp(pp) {
      this.selectedPpDetails = this.publicPrograms.find((p) => p.id === pp.id) || pp;
      this.modalDetalhesPp = true;
    },

    abrirNovoPublicProgramParaLinha(row) {
      this._ppTargetRow = row;
      this.novoPublicProgramForm = EMPTY_PUBLIC_PROGRAM();
      this.novoPublicProgramLogo = null;
      this.modalNovoPublicProgram = true;
    },

    resetNovoPublicProgramForm() {
      this.novoPublicProgramForm = EMPTY_PUBLIC_PROGRAM();
      this.novoPublicProgramLogo = null;
      this._ppTargetRow = null;
    },

    async salvarNovoPublicProgram(evt) {
      evt.preventDefault();
      if (!this.novoPublicProgramForm.name.trim()) {
        this.$notify({ data: ["Nome é obrigatório."], type: "warn" });
        return;
      }
      try {
        const r = await ActionPlanService.CreatePublicProgram(this.contaId, {
          name: this.novoPublicProgramForm.name.trim(),
          description: this.novoPublicProgramForm.description || null,
        });
        const newPp = r.data;
        if (this.novoPublicProgramLogo) {
          await ActionPlanService.UploadLogo(this.contaId, newPp.id, this.novoPublicProgramLogo);
        }
        this.publicPrograms.push(newPp);
        if (this._ppTargetRow) {
          this._ppTargetRow.linked_public_programs.push({ id: newPp.id, name: newPp.name, logo_url: newPp.logo_url || null });
          if (this._ppTargetRow._status === "saved") this._ppTargetRow._status = "modified";
        }
        this.$notify({ data: ["Programa público criado."], type: "success" });
        this.modalNovoPublicProgram = false;
      } catch {
        this.$notify({ data: ["Erro ao criar programa público."], type: "error" });
      }
    },

    // ── Progresso de metas ──────────────────────────────────────────────────

    abrirProgressoLinha(row) {
      this.abrirProgresso({
        id: row.program_id,
        name: row.program_name,
        unit: row.unit,
        unit_label: row.unit_label,
        goal_2yr: row.goal_2yr,
        goal_5yr: row.goal_5yr,
        goal_10yr: row.goal_10yr,
      });
    },

    abrirProgresso(program) {
      this.selectedProgram = program;
      this.progressoForm = EMPTY_PROGRESSO();
      this.modalProgresso = true;
      this.loadingProgresso = true;
      ActionPlanService.ListProgress(this.contaId, program.id)
        .then((r) => { this.progressEntries = r.data; })
        .catch(() => this.$notify({ data: ["Erro ao carregar histórico de progresso."], type: "error" }))
        .finally(() => { this.loadingProgresso = false; });
    },

    resetProgressoModal() {
      this.selectedProgram = null;
      this.progressEntries = [];
      this.progressoForm = EMPTY_PROGRESSO();
    },

    salvarProgresso() {
      if (this.progressoForm.achieved_value === null || this.progressoForm.achieved_value === "") {
        this.$notify({ data: ["Valor atingido é obrigatório."], type: "warn" });
        return;
      }
      if (!this.progressoForm.reference_date) {
        this.$notify({ data: ["Data de referência é obrigatória."], type: "warn" });
        return;
      }
      this.savingProgresso = true;
      const payload = {
        achieved_value: this.progressoForm.achieved_value,
        reference_date: this.progressoForm.reference_date,
        notes: this.progressoForm.notes || null,
      };
      ActionPlanService.AddProgress(this.contaId, this.selectedProgram.id, payload)
        .then((r) => {
          this.progressEntries = [r.data, ...this.progressEntries];
          this.progressoForm = EMPTY_PROGRESSO();
          this.$notify({ data: ["Progresso registrado."], type: "success" });
        })
        .catch(() => this.$notify({ data: ["Erro ao registrar progresso."], type: "error" }))
        .finally(() => { this.savingProgresso = false; });
    },

    excluirProgresso(entry) {
      if (!confirm("Excluir este registro de progresso?")) return;
      ActionPlanService.DeleteProgress(this.contaId, this.selectedProgram.id, entry.id)
        .then(() => {
          this.progressEntries = this.progressEntries.filter((e) => e.id !== entry.id);
          this.$notify({ data: ["Registro excluído."], type: "success" });
        })
        .catch(() => this.$notify({ data: ["Erro ao excluir registro."], type: "error" }));
    },

    // ── Admin — Eixos ───────────────────────────────────────────────────────

    carregarAdminAxes() {
      this.loadingAdminAxes = true;
      ActionPlanService.AdminListAxes(true)
        .then((r) => { this.adminAxes = r.data; })
        .catch(() => this.$notify({ data: ["Erro ao carregar eixos admin."], type: "error" }))
        .finally(() => { this.loadingAdminAxes = false; });
    },

    abrirNovoEixoAdmin() {
      this.editandoEixoAdmin = null;
      this.eixoAdminForm = { name: "", description: "", is_active: true };
      this.modalEixoAdmin = true;
    },

    abrirEditarEixoAdmin(axis) {
      this.editandoEixoAdmin = axis;
      this.eixoAdminForm = { name: axis.name, description: axis.description || "", is_active: axis.is_active };
      this.modalEixoAdmin = true;
    },

    resetEixoAdminForm() {
      this.editandoEixoAdmin = null;
      this.eixoAdminForm = { name: "", description: "", is_active: true };
    },

    salvarEixoAdmin(evt) {
      evt.preventDefault();
      if (!this.eixoAdminForm.name.trim()) {
        this.$notify({ data: ["Nome é obrigatório."], type: "warn" });
        return;
      }
      const payload = { name: this.eixoAdminForm.name.trim(), description: this.eixoAdminForm.description || null, is_active: this.eixoAdminForm.is_active };
      const req = this.editandoEixoAdmin
        ? ActionPlanService.AdminUpdateAxis(this.editandoEixoAdmin.id, payload)
        : ActionPlanService.AdminCreateAxis(payload);
      req
        .then(() => {
          this.$notify({ data: ["Eixo salvo."], type: "success" });
          this.modalEixoAdmin = false;
          this.carregarAdminAxes();
        })
        .catch(() => this.$notify({ data: ["Erro ao salvar eixo."], type: "error" }));
    },

    excluirEixoAdmin(axis) {
      if (!confirm(`Excluir o eixo template "${axis.name}"?`)) return;
      ActionPlanService.AdminDeleteAxis(axis.id)
        .then(() => {
          this.$notify({ data: ["Eixo excluído."], type: "success" });
          this.carregarAdminAxes();
        })
        .catch(() => this.$notify({ data: ["Erro ao excluir eixo."], type: "error" }));
    },

    // ── Admin — Programas ───────────────────────────────────────────────────

    carregarAdminPrograms() {
      if (this.adminPrograms.length > 0) return;
      this.loadingAdminPrograms = true;
      ActionPlanService.AdminListPrograms(null, true)
        .then((r) => { this.adminPrograms = r.data; })
        .catch(() => this.$notify({ data: ["Erro ao carregar programas admin."], type: "error" }))
        .finally(() => { this.loadingAdminPrograms = false; });
    },

    abrirNovoProgramaAdmin() {
      this.editandoProgramaAdmin = null;
      this.programaAdminForm = { ...EMPTY_PROGRAMA(), is_active: true };
      this.modalProgramaAdmin = true;
    },

    abrirEditarProgramaAdmin(program) {
      this.editandoProgramaAdmin = program;
      this.programaAdminForm = {
        strategic_axis_id: program.strategic_axis_id,
        name: program.name,
        description: program.description || "",
        strategic_objective: program.strategic_objective || "",
        strategic_actors: program.strategic_actors || "",
        tangible_goal: program.tangible_goal || "",
        unit: program.unit,
        unit_label: program.unit_label || "",
        goal_2yr: program.goal_2yr,
        goal_5yr: program.goal_5yr,
        goal_10yr: program.goal_10yr,
        is_active: program.is_active,
      };
      this.modalProgramaAdmin = true;
    },

    resetProgramaAdminForm() {
      this.editandoProgramaAdmin = null;
      this.programaAdminForm = { ...EMPTY_PROGRAMA(), is_active: true };
    },

    salvarProgramaAdmin(evt) {
      evt.preventDefault();
      if (!this.programaAdminForm.name.trim() || !this.programaAdminForm.strategic_axis_id) {
        this.$notify({ data: ["Nome e eixo são obrigatórios."], type: "warn" });
        return;
      }
      const payload = {
        ...this.programaAdminForm,
        name: this.programaAdminForm.name.trim(),
        description: this.programaAdminForm.description || null,
        strategic_objective: this.programaAdminForm.strategic_objective || null,
        strategic_actors: this.programaAdminForm.strategic_actors || null,
        tangible_goal: this.programaAdminForm.tangible_goal || null,
        unit_label: this.programaAdminForm.unit_label || null,
      };
      const req = this.editandoProgramaAdmin
        ? ActionPlanService.AdminUpdateProgram(this.editandoProgramaAdmin.id, payload)
        : ActionPlanService.AdminCreateProgram(payload);
      req
        .then(() => {
          this.$notify({ data: ["Programa salvo."], type: "success" });
          this.modalProgramaAdmin = false;
          this.adminPrograms = [];
          this.carregarAdminPrograms();
        })
        .catch((e) => {
          const msg = e?.response?.data?.detail || "Erro ao salvar programa.";
          this.$notify({ data: [msg], type: "error" });
        });
    },

    excluirProgramaAdmin(program) {
      if (!confirm(`Excluir o programa template "${program.name}"?`)) return;
      ActionPlanService.AdminDeleteProgram(program.id)
        .then(() => {
          this.$notify({ data: ["Programa excluído."], type: "success" });
          this.adminPrograms = this.adminPrograms.filter((p) => p.id !== program.id);
        })
        .catch(() => this.$notify({ data: ["Erro ao excluir programa."], type: "error" }));
    },

    // ── Admin — Importação em massa via planilha ─────────────────────────────

    abrirImportarProgramasAdmin() {
      this.resetImportProgramsModal();
      this.modalImportPrograms = true;
    },

    resetImportProgramsModal() {
      this.importProgramsFile = null;
      this.importingPrograms = false;
      this.importProgramsResult = null;
      this.importProgramsErrors = [];
    },

    executarImportacaoAdmin(evt) {
      evt.preventDefault();
      if (!this.importProgramsFile || this.importingPrograms) return;
      this.importingPrograms = true;
      this.importProgramsResult = null;
      this.importProgramsErrors = [];
      ActionPlanService.AdminImportPrograms(this.importProgramsFile)
        .then((r) => {
          this.importProgramsResult = r.data;
          this.$notify({ data: ["Planilha importada com sucesso."], type: "success" });
          this.adminAxes = [];
          this.adminPrograms = [];
          this.adminPublicPrograms = [];
          this.carregarAdminAxes();
        })
        .catch((e) => {
          const detail = e?.response?.data?.detail;
          this.importProgramsErrors = Array.isArray(detail?.errors)
            ? detail.errors
            : [detail || "Erro ao importar planilha."];
        })
        .finally(() => { this.importingPrograms = false; });
    },

    // ── Admin — Programas Públicos ──────────────────────────────────────────

    carregarAdminPublicPrograms() {
      if (this.adminPublicPrograms.length > 0) return;
      this.loadingAdminPublicPrograms = true;
      ActionPlanService.AdminListPublicPrograms(true)
        .then((r) => { this.adminPublicPrograms = r.data; })
        .catch(() => this.$notify({ data: ["Erro ao carregar programas públicos admin."], type: "error" }))
        .finally(() => { this.loadingAdminPublicPrograms = false; });
    },

    abrirNovoPublicProgramAdmin() {
      this.editandoPublicProgramAdmin = null;
      this.publicProgramAdminForm = { name: "", description: "", is_active: true };
      this.modalPublicProgramAdmin = true;
    },

    abrirEditarPublicProgramAdmin(pp) {
      this.editandoPublicProgramAdmin = pp;
      this.publicProgramAdminForm = { name: pp.name, description: pp.description || "", is_active: pp.is_active };
      this.modalPublicProgramAdmin = true;
    },

    resetPublicProgramAdminForm() {
      this.editandoPublicProgramAdmin = null;
      this.publicProgramAdminForm = { name: "", description: "", is_active: true };
    },

    salvarPublicProgramAdmin(evt) {
      evt.preventDefault();
      if (!this.publicProgramAdminForm.name.trim()) {
        this.$notify({ data: ["Nome é obrigatório."], type: "warn" });
        return;
      }
      const payload = { name: this.publicProgramAdminForm.name.trim(), description: this.publicProgramAdminForm.description || null, is_active: this.publicProgramAdminForm.is_active };
      const req = this.editandoPublicProgramAdmin
        ? ActionPlanService.AdminUpdatePublicProgram(this.editandoPublicProgramAdmin.id, payload)
        : ActionPlanService.AdminCreatePublicProgram(payload);
      req
        .then(() => {
          this.$notify({ data: ["Programa público salvo."], type: "success" });
          this.modalPublicProgramAdmin = false;
          this.adminPublicPrograms = [];
          this.carregarAdminPublicPrograms();
        })
        .catch(() => this.$notify({ data: ["Erro ao salvar programa público."], type: "error" }));
    },

    excluirPublicProgramAdmin(pp) {
      if (!confirm(`Excluir o programa público template "${pp.name}"?`)) return;
      ActionPlanService.AdminDeletePublicProgram(pp.id)
        .then(() => {
          this.$notify({ data: ["Programa público excluído."], type: "success" });
          this.adminPublicPrograms = this.adminPublicPrograms.filter((p) => p.id !== pp.id);
        })
        .catch(() => this.$notify({ data: ["Erro ao excluir programa público."], type: "error" }));
    },

    abrirUploadLogoAdmin(pp) {
      this.uploadingLogo = pp;
      this.uploadLogoFile = null;
      this.modalUploadLogo = true;
    },

    salvarUploadLogoAdmin(evt) {
      evt.preventDefault();
      if (!this.uploadLogoFile) return;
      ActionPlanService.AdminUploadLogo(this.uploadingLogo.id, this.uploadLogoFile)
        .then((r) => {
          const idx = this.adminPublicPrograms.findIndex((p) => p.id === this.uploadingLogo.id);
          if (idx >= 0) this.adminPublicPrograms.splice(idx, 1, r.data);
          this.$notify({ data: ["Logo atualizado."], type: "success" });
          this.modalUploadLogo = false;
        })
        .catch(() => this.$notify({ data: ["Erro ao enviar logo."], type: "error" }));
    },

    // ── Admin — Vínculos ────────────────────────────────────────────────────

    abrirGerenciarVinculosAdmin(program) {
      this.selectedAdminProgram = program;
      this.novoVinculoPpIdAdmin = null;
      this.modalVinculosAdmin = true;
      this.loadingVinculosAdmin = true;
      if (this.adminPublicPrograms.length === 0) {
        ActionPlanService.AdminListPublicPrograms(false).then((r) => { this.adminPublicPrograms = r.data; });
      }
      ActionPlanService.AdminListProgramLinks(program.id)
        .then((r) => { this.adminProgramLinks = r.data; })
        .catch(() => this.$notify({ data: ["Erro ao carregar vínculos."], type: "error" }))
        .finally(() => { this.loadingVinculosAdmin = false; });
    },

    resetVinculosAdminModal() {
      this.selectedAdminProgram = null;
      this.adminProgramLinks = [];
      this.novoVinculoPpIdAdmin = null;
    },

    adicionarVinculoAdmin() {
      if (!this.novoVinculoPpIdAdmin) return;
      ActionPlanService.AdminAddProgramLink(this.selectedAdminProgram.id, this.novoVinculoPpIdAdmin)
        .then(() => {
          const pp = this.adminPublicPrograms.find((p) => p.id === this.novoVinculoPpIdAdmin);
          if (pp) this.adminProgramLinks.push(pp);
          this.novoVinculoPpIdAdmin = null;
          this.$notify({ data: ["Vínculo adicionado."], type: "success" });
        })
        .catch((e) => {
          const msg = e?.response?.data?.detail || "Erro ao adicionar vínculo.";
          this.$notify({ data: [msg], type: "error" });
        });
    },

    removerVinculoAdmin(pp) {
      if (!confirm(`Desvincular "${pp.name}"?`)) return;
      ActionPlanService.AdminRemoveProgramLink(this.selectedAdminProgram.id, pp.id)
        .then(() => {
          this.adminProgramLinks = this.adminProgramLinks.filter((p) => p.id !== pp.id);
          this.$notify({ data: ["Vínculo removido."], type: "success" });
        })
        .catch(() => this.$notify({ data: ["Erro ao remover vínculo."], type: "error" }));
    },

    // ── Progresso das Metas ─────────────────────────────────────────────────

    ativarAbaProgresso() {
      this.progressTabActivated = true;
      if (!this.progressTabLoaded && !this.loadingProgressTab && !this.loadingTecnico && this.programs.length) {
        this.carregarTodosProgressos();
      }
    },

    recarregarProgressos() {
      this.progressTabLoaded = false;
      this.allProgressEntries = {};
      this.carregarTodosProgressos();
    },

    carregarTodosProgressos() {
      if (!this.programs.length) return;
      this.loadingProgressTab = true;
      Promise.all(
        this.programs.map((p) =>
          ActionPlanService.ListProgress(this.contaId, p.id)
            .then((r) => ({ id: p.id, data: r.data }))
            .catch(() => ({ id: p.id, data: [] }))
        )
      )
        .then((results) => {
          const map = {};
          for (const { id, data } of results) {
            map[id] = data;
          }
          this.allProgressEntries = map;
          this.progressTabLoaded = true;
        })
        .catch(() => {
          this.$notify({ data: ["Erro ao carregar dados de progresso."], type: "error" });
        })
        .finally(() => {
          this.loadingProgressTab = false;
        });
    },

    salvarDataInicio() {
      if (!this.planStartDateVarId) return;
      this.savingPlanStartDate = true;
      ActionPlanService.SaveVariable(this.contaId, this.planStartDateVarId, this.planStartDate)
        .then(() => {
          this.$notify({ data: ["Data de início salva."], type: "success" });
          if (this.progressTabLoaded) {
            this.progressTabLoaded = false;
            this.allProgressEntries = {};
            this.carregarTodosProgressos();
          }
        })
        .catch(() => { this.$notify({ data: ["Erro ao salvar data de início."], type: "error" }); })
        .finally(() => { this.savingPlanStartDate = false; });
    },

    _filterByPeriod(entries, years) {
      const sorted = [...entries].sort((a, b) => new Date(b.reference_date) - new Date(a.reference_date));
      if (!this.planStartDate) return sorted;
      const start = new Date(this.planStartDate + "T00:00:00");
      const end = new Date(start.getFullYear() + years, start.getMonth(), start.getDate());
      return sorted.filter((e) => {
        const d = new Date(e.reference_date + "T00:00:00");
        return d >= start && d <= end;
      });
    },

    periodoFim(years) {
      if (!this.planStartDate) return "";
      const start = new Date(this.planStartDate + "T00:00:00");
      const end = new Date(start.getFullYear() + years, start.getMonth(), start.getDate());
      return end.toLocaleDateString("pt-BR", { month: "short", year: "numeric" });
    },

    periodoLabel(years) {
      if (!this.planStartDate) return "";
      const start = new Date(this.planStartDate + "T00:00:00");
      const end = new Date(start.getFullYear() + years, start.getMonth(), start.getDate());
      const fmt = (d) => d.toLocaleDateString("pt-BR", { month: "short", year: "numeric" });
      return `${fmt(start)} → ${fmt(end)}`;
    },
  },
};
</script>

<style scoped>
.ap-table-wrapper {
  max-height: 75vh;
  overflow: auto;
}
.ap-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  white-space: nowrap;
}
.ap-table td {
  vertical-align: top;
  padding: 4px 5px;
}
.ap-textarea {
  resize: vertical;
  min-height: 34px;
}
.badge-pp {
  font-size: 11px;
  padding: 3px 5px;
  white-space: normal;
  text-align: left;
  display: inline-flex;
  align-items: center;
}
.btn-remove-pp {
  background: none;
  border: none;
  color: rgba(255,255,255,0.8);
  padding: 0 0 0 4px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
}
.btn-remove-pp:hover {
  color: #fff;
}
.ap-badge {
  font-size: 10px;
}
.ap-row-error {
  font-size: 10px;
  max-width: 85px;
  word-break: break-word;
  margin-top: 2px;
}
.tr-saved {
  background-color: #f6fff6;
}
.tr-modified {
  background-color: #fffdf0;
}
</style>
